import React from 'react';
import PropTypes from 'prop-types';
import { Link } from "gatsby";

const SelectLanguage = (props) => {
    const links = props.langs.map(lang => {
        if (lang.selected !== true) {
            return (<Link to={lang.link} key={lang.langKey} style={{
                color: 'black'
            }}>
                <img src={lang.icon} alt="Oberlin" style={{ width: "32px" }} />
            </Link>)
        } else {
            return <></>;
        }
    });

    return (
        <div className="navbar-item py-3">
            <ul>
                {links}
            </ul>
        </div>
    );
};

SelectLanguage.propTypes = {
    langs: PropTypes.array
};

export default SelectLanguage;